import { useController, Control } from 'react-hook-form';

import { BulkLiftSuspensionFormValues } from './types';
import {
  createMaxLengthValidator,
  isRequired,
  isValidInput,
} from '../../validators';

export const useControllers = (
  control: Control<
    BulkLiftSuspensionFormValues,
    any,
    BulkLiftSuspensionFormValues
  >
) => {
  const {
    field: {
      value: explanation,
      onChange: setExplanation,
      onBlur: validateExplanation,
    },
    fieldState: { error: explanationError },
  } = useController({
    control,
    name: 'explanation',
    rules: {
      validate: {
        isRequired,
        isValidInput,
        withValidMaxLength: createMaxLengthValidator(3000),
      },
    },
  });

  return {
    explanation,
    setExplanation,
    validateExplanation,
    explanationError,
  };
};
